import config from "../config/application";
import {
  apiCall
} from "./common/base.service";
import dictionary from '../config/dictionary';
import permission from "./permissions.service";

//url
const findUser = '/find/user';
const change = '/status';
const changeStatus = '/changeStatus';


class UsersService {
  getUsers(filterJson) {
    const url = `${config.data.providers.users.url}${findUser}`;
    return apiCall('put', url, filterJson);
  }

  updateStatus = async (filterJson) => {
    const url = `${config.data.providers.users.url}${change}`;
    const validPermission = await userArea.getPermissions(filterJson.userPermission, dictionary.configApp.action.edit)
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall('put', url, filterJson);
  }

  updateStatusCognito(filterJson) {
    const url = `${config.data.providers.users.url}${change}`;
    return apiCall('put', url, filterJson);
  }

  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_USER,
      username,
      process.env.REACT_APP_SYSTEM_CODE, action);
  }
  updateUser(data) {
    const url = `${config.data.providers.users.url}${changeStatus}`
    return apiCall("post", url, data.payload)
  }
}

const userArea = new UsersService();
export default userArea; 